var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slidefade"}},[(_vm.showModal && _vm.product.id)?_c('div',{staticClass:"modal"},[_c('ManageProductDetail',{attrs:{"product":_vm.product},on:{"change":_vm.change}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }